<div class="tv-accounts-card"
  *ngIf="accountDetails?.instagram_id || accountDetails?.twitter_id || accountDetails?.facebook_id">
  <div class="tv-accounts-header">
    <span class="tv-accounts-icon">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
      </svg>
    </span>
    <span class="tv-accounts-title">Official Channels</span>
  </div>
  <div class="tv-accounts-list">
    <a *ngIf="accountDetails?.instagram_id" [href]="'https://www.instagram.com/' + accountDetails?.instagram_id"
      target="_blank" rel="noopener noreferrer" class="account-link-chip account-ig" title="Instagram">
      <i class="ri-instagram-line"></i>
      <span>Instagram</span>
    </a>
    <a *ngIf="accountDetails?.twitter_id" [href]="'https://www.x.com/' + accountDetails?.twitter_id" target="_blank"
      rel="noopener noreferrer" class="account-link-chip account-x" title="X (Twitter)">
      <i class="ri-twitter-x-line"></i>
      <span>X</span>
    </a>
    <a *ngIf="accountDetails?.facebook_id" [href]="'https://www.facebook.com/' + accountDetails?.facebook_id"
      target="_blank" rel="noopener noreferrer" class="account-link-chip account-fb" title="Facebook">
      <i class="ri-facebook-line"></i>
      <span>Facebook</span>
    </a>
  </div>
</div>